var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var _a;
import React, { Component } from 'react';
import cxs from 'cxs/component';
import theme, { mediaQueries } from '../Theme';
import { Button } from '../elements';
import { inject } from 'mobx-react';
import { T } from '../helpers/i18n';
import FieldPrice from './FieldPrice';
var PricesView = /** @class */ (function (_super) {
    __extends(PricesView, _super);
    function PricesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PricesView.prototype.render = function () {
        var _a = this.props, label = _a.label, priceFields = _a.priceFields, pricesValues = _a.pricesValues, isPriceCalendar = _a.isPriceCalendar, onChange = _a.onChange, onSave = _a.onSave, onSavePrice = _a.onSavePrice, onDeleteClick = _a.onDeleteClick, onDefaultPrice = _a.onDefaultPrice;
        // console.log('PriceView - pricesValues: ', pricesValues)
        return (React.createElement(WrapperPrices, { style: {
                borderRadius: 10
            } },
            React.createElement(WrapperLabel, null, label),
            priceFields.length > 0 && (React.createElement(WrapperPrice, null, priceFields.map(function (field) {
                return (React.createElement(FieldPrice, { key: "View_".concat(field.name), field: field, isPriceCalendar: isPriceCalendar, pricesValues: pricesValues, onChangePrice: onChange, onSavePrice: onSavePrice, onDeleteClick: onDeleteClick, onDefaultPrice: onDefaultPrice }));
            }))),
            priceFields.length === 0 && (React.createElement("div", null, "No hay categor\u00EDas de pasajero, por favor a\u00F1ada categor\u00EDas de pasajero")),
            onSave && (React.createElement(Button, { primary: true, onClick: onSave }, T('save')))));
    };
    PricesView = __decorate([
        inject('store')
    ], PricesView);
    return PricesView;
}(Component));
export default PricesView;
var borderStyle = {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.color.hairline,
    animation: ''
};
var WrapperPrices = cxs('div')(__assign(__assign({}, borderStyle), { padding: '5px', display: 'block', margin: '20px', marginTop: '10px' }));
var WrapperPrice = cxs('div')((_a = {
        paddingLeft: '20px'
    },
    _a[mediaQueries.desktop] = {
        display: 'flex',
        flexWrap: 'wrap',
        paddingBottom: 0
    },
    _a));
var WrapperLabel = cxs('label')({
    fontSize: 'large',
    paddingTop: '30px',
    marginLeft: '20px'
});



//////////////////
// WEBPACK FOOTER
// ./src/components/PricesView.tsx
// module id = 545
// module chunks = 0